import { render, staticRenderFns } from "./liveClassFestival.vue?vue&type=template&id=2a18b478"
import script from "./liveClassFestival.vue?vue&type=script&lang=js"
export * from "./liveClassFestival.vue?vue&type=script&lang=js"
import style0 from "./liveClassFestival.vue?vue&type=style&index=0&id=2a18b478&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports